// import Vue from 'vue';

export default {
  FORCE_UPDATE_KEY(st) {
    // eslint-disable-next-line no-param-reassign
    st.forceUpdateKey += 1;
  },
  // INDEX_BANNER_STATE(st, payload) {
  //   // eslint-disable-next-line no-param-reassign
  //   st.indexBanner = payload;
  // },
  RWD_TYPE(st, payload) {
    // eslint-disable-next-line no-param-reassign
    st.screenStatus.rwdType = payload;
  },
  FLOW_BAR_FIXED(st, payload) {
    // eslint-disable-next-line no-param-reassign
    st.screenStatus.flowBarFixed = payload;
  },
  POPBOX_STATUS(st, payload) {
    // eslint-disable-next-line no-param-reassign
    st.popBox = payload;
  },
  POPSTARTUP_STATUS(st, payload) {
    // eslint-disable-next-line no-param-reassign
    st.popStartupBox = payload;
  },
  POPPROGRESS_STATUS(st, payload) {
    // eslint-disable-next-line no-param-reassign
    st.popProgressBox = payload;
  },
  POPBLOOD_UPLOAD_STATUS(st, payload) {
    // eslint-disable-next-line no-param-reassign
    st.popBloodUploadBox = payload;
  },
  POPTRANSLATOR_STATUS(st, payload) {
    // eslint-disable-next-line no-param-reassign
    st.popTranslator = payload;
  },
  POPANALYSIS_STATUS(st, payload) {
    // eslint-disable-next-line no-param-reassign
    st.popAnalysis = payload;
  },
  POPDIET_RECOGNIZE_STATUS(st, payload) {
    // eslint-disable-next-line no-param-reassign
    st.popDietRecognize = payload;
  },
  POPSHOW_TUTORIAL_STATUS(st, payload) {
    // eslint-disable-next-line no-param-reassign
    st.popShowTutorial = payload;
  },
  POPYOUTUBE_STATUS(st, payload) {
    // eslint-disable-next-line no-param-reassign
    st.popYoutubePlayer = payload;
  },
  POPBUSINESS_REQUEST(st, payload) {
    // eslint-disable-next-line no-param-reassign
    st.popBusinessRequest = payload;
  },
  POPCOURSE_STATUS(st, payload) {
    // eslint-disable-next-line no-param-reassign
    st.popCoursePlayer = payload;
  },
  POPZOOM_STATUS(st, payload) {
    // eslint-disable-next-line no-param-reassign
    st.popImgZoom = payload;
  },
  POPQRCODE_STATUS(st, payload) {
    // eslint-disable-next-line no-param-reassign
    st.popQrCode = payload;
  },
  POPTEAM_FEATURE_STATUS(st, payload) {
    // eslint-disable-next-line no-param-reassign
    st.popTeamFeature = payload;
  },
  POPDRUG_STATUS(st, payload) {
    // eslint-disable-next-line no-param-reassign
    st.popDrugBox = payload;
  },
  // POPSHOP_STUFF_STATUS(st, payload) {
  //   // eslint-disable-next-line no-param-reassign
  //   st.popShopStuffBox = payload;
  // },
  // POPSHOP_BUNDLE_STATUS(st, payload) {
  //   // eslint-disable-next-line no-param-reassign
  //   st.popShopBundleBox = payload;
  // },
  POPAGREE_LIST_STATUS(st, payload) {
    // eslint-disable-next-line no-param-reassign
    st.popAgreeList = payload;
  },
  POPCHAT_ADDITIONAL_STATUS(st, payload) {
    // eslint-disable-next-line no-param-reassign
    st.popChatAdditional = payload;
  },
  POPQUESTION_STATUS(st, payload) {
    // eslint-disable-next-line no-param-reassign
    st.popControlQuestion = payload;
  },
  // POPDELETE_RESUME_STATUS(st, payload) {
  //   // eslint-disable-next-line no-param-reassign
  //   st.popDeleteResume = payload;
  // },
  // POPBLESS_STATUS(st, payload) {
  //   // eslint-disable-next-line no-param-reassign
  //   st.popSendBless = payload;
  // },
  // POPDELETE_BLESS_STATUS(st, payload) {
  //   // eslint-disable-next-line no-param-reassign
  //   st.popDeleteBless = payload;
  // },
  // POPDELETE_REPLY_STATUS(st, payload) {
  //   // eslint-disable-next-line no-param-reassign
  //   st.popDeleteReply = payload;
  // },
  // POPDELETE_ASK_STATUS(st, payload) {
  //   // eslint-disable-next-line no-param-reassign
  //   st.popDeleteAsk = payload;
  // },
  POPDELETE_TRANSLATION_STATUS(st, payload) {
    // eslint-disable-next-line no-param-reassign
    st.popDeleteTranslation = payload;
  },
  POPDELETE_EPRO_STATUS(st, payload) {
    // eslint-disable-next-line no-param-reassign
    st.popDeleteEpro = payload;
  },
  POPREPORT_STATUS(st, payload) {
    // eslint-disable-next-line no-param-reassign
    st.popReport = payload;
  },
  POPHELP_FILTER_STATUS(st, payload) {
    // eslint-disable-next-line no-param-reassign
    st.popHelpFilter = payload;
  },
  POPFREETRAIL_STATUS(st, payload) {
    // eslint-disable-next-line no-param-reassign
    st.popFreeTrail = payload;
  },
  // POPRECORD_ADVISE_STATUS(st, payload) {
  //   // eslint-disable-next-line no-param-reassign
  //   st.popRecordAdvise = payload;
  // },
  POPLATEST_NEWS_STATUS(st, payload) {
    // eslint-disable-next-line no-param-reassign
    st.popLatestNews = payload;
  },
  POPVENDORPROFILE_STATUS(st, payload) {
    // eslint-disable-next-line no-param-reassign
    st.popVendorProfile = payload;
  },
  POPEPRO_RECORD_DETAIL(st, payload) {
    // eslint-disable-next-line no-param-reassign
    st.popEproRecordDetail = payload;
  },
  POPCHRONIC_BLOOD_DETAIL(st, payload) {
    // eslint-disable-next-line no-param-reassign
    st.popChronicBloodDetail = payload;
  },
  POPCHECKLIST_STATUS(st, payload) {
    // eslint-disable-next-line no-param-reassign
    st.popCheckListBox = payload;
  },
};
